import { Card, useTheme } from "@mui/material";
import styles from "./DomainOption.module.css";

interface Props {
    text: string;
    value: string;
    onClick: (value: string) => void;
}

export const DomainOption = ({ text, value, onClick }: Props) => {
    const theme = useTheme();
    const bgColor = theme.palette.background.default;

    return (
        <Card style={{ backgroundColor: bgColor }} className={styles.domainOption} onClick={() => onClick(value)}>
            <p style={{ color: theme.palette.getContrastText(bgColor) }} className={styles.domainOptionText}>
                {text}
            </p>
        </Card>
    );
};
